import {Component, Input, signal} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {NbButtonModule, NbCardModule, NbDialogRef, NbIconModule, NbToastrService} from "@nebular/theme";
import {PlayersService} from "../../../services/players.service";
import {notificationsParams} from "../../../shared/settings";
import {FormInputComponent} from "../../../shared/components/forms/form-input/form-input.component";
import {StorageService} from "../../../services/storage.service";
import {TranslateModule, TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-team-form',
  standalone: true,
  imports: [
    TranslateModule,
    FormsModule,
    NbButtonModule,
    NbCardModule,
    NbIconModule,
    ReactiveFormsModule,
    FormInputComponent,
  ],
  templateUrl: './account-infos-form.component.html',
  styleUrl: './account-infos-form.component.scss'
})
export class AccountInfosFormComponent {
  loading = false;
  accountActivisionForm!: FormGroup;
  @Input() user: any;
  status = signal<any[]>([]);

  constructor(private fb: FormBuilder, private playersService: PlayersService, private storageService: StorageService,
              private toastrService: NbToastrService, protected dialogRef: NbDialogRef<any>, private translate: TranslateService) {}

  ngOnInit(): void {
    this.accountActivisionForm = this.fb.group({
      email: [this.user.new_email ? this.user.new_email : this.user.email, [Validators.required]],
      account_activision: [this.user.new_account_activision ? this.user.new_account_activision : this.user.account_activision,
        this.isUserInternal() ? [] : [Validators.required]],
    });
  }

  cancel() {
    this.dialogRef.close();
  }

  submit() {
    const email = this.accountActivisionForm.value.email;
    const accountActivision = this.accountActivisionForm.value.account_activision;

    this.playersService.updateAccountInfos(email, accountActivision).subscribe(() => {
      const modifiedUser = this.storageService.user();

      modifiedUser.new_account_activision = accountActivision;
      this.user.new_account_activision = accountActivision;

      modifiedUser.new_email = email;
      this.user.new_email = email;

      this.storageService.saveUser(modifiedUser)
      this.toastrService.success(this.translate.instant('auth.account.updated'), this.translate.instant('common.information'), notificationsParams);
      this.dialogRef.close();
    });
  }

  protected isUserInternal() {
    return this.user?.internal === true;
  }

  getControl(controlName: string): FormControl {
    return this.accountActivisionForm.get(controlName) as FormControl;
  }
}
